import { useCallback, useState } from "react";
import { getStudyGroupUnreadCounts } from "@/lib/humhub-api/studyGroups";
import type { StudyGroupUnreadTotals } from "@/lib/humhub-api/types";

export const useStudyGroupUnreadCounts = () => {
  const [totalUnreadCounts, setTotalUnreadCounts] =
    useState<StudyGroupUnreadTotals>({
      unreadPostCommentCount: 0,
      unreadMentions: 0,
    });

  const refreshUnreadCounts = useCallback(async () => {
    const counts = await getStudyGroupUnreadCounts();
    setTotalUnreadCounts(counts);
    return counts;
  }, []);

  return { totalUnreadCounts, refreshUnreadCounts };
};
